export default __webpack_public_path__ + "static/media/download_circle_icon.5a6c543d.svg";